import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { REQUEST_STATUS } from '../../../constants/request'
import { stopPropagation } from '../../../utils/events'
import { EntityArchivedIcon, EntityStatus, EntityTag } from '../../Entity'
import { STATUS_SIZE_20 } from '../../Status'
import { getTagActionSize, TAG_HEIGHT } from '../../Tag'
import { getRequestTagTooltip, getRequestTitle } from '../Request.utils'

import * as styles from './RequestTag.module.css'

import ServiceRequestIcon from '../../../icons/service-request.svg'

function RequestTag({
  Icon = ServiceRequestIcon,
  archived,
  avatarProps: {
    Icon: AvatarIcon = ServiceRequestIcon,
    ...avatarProps
  } = EMPTY_OBJECT,
  className = styles.RequestTag,
  getText = getRequestTitle,
  getTooltipContent = getRequestTagTooltip,
  hasAvatar,
  height = TAG_HEIGHT.height32,
  iconProps,
  id,
  qaName,
  removeTooltipKey,
  request_no: requestNumber,
  status,
  statusSize = STATUS_SIZE_20,
  title,
  onClick,
  onMouseDown,
  onRemove,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)

    onClick?.(id, event)
  }

  function handleMouseDown(event) {
    stopPropagation(event)

    onMouseDown?.(id, event)
  }

  function handleRemove(event) {
    stopPropagation(event)

    onRemove(id, event)
  }

  return (
    <EntityTag
      Icon={Icon}
      afterContent={
        archived ? (
          <EntityArchivedIcon size={getTagActionSize(height)} tooltip={null} />
        ) : null
      }
      avatarProps={hasAvatar ? { ...avatarProps, Icon: AvatarIcon } : undefined}
      className={className}
      height={height}
      iconProps={iconProps}
      meta={
        Number.isFinite(status) ? (
          <EntityStatus
            height={statusSize}
            id={status}
            statuses={REQUEST_STATUS}
          />
        ) : null
      }
      name={getText({ requestNumber, title })}
      qaName={qaName}
      removeTooltipKey={removeTooltipKey}
      tooltip={getTooltipContent({ archived, requestNumber, status, t, title })}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onRemove={onRemove ? handleRemove : undefined}
    />
  )
}

export default RequestTag
